export default "__VITE_ASSET__CG2D2egs__"